export const ProjectTrackingData = [
  {
    title: 'Customer onboarded',
    date: '12 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'Documents verification',
    date: '16 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'Feasibility Check',
    date: '17 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'PDD shared with registry',
    date: '18 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'Auditor Assigned',
    date: '19 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'Project in Progress',
    date: '24 Jun 2021',
    status: 'Completed',
  },
  {
    title: 'Progress check 1',
    date: '24 Jun 2022',
    status: 'Completed',
  },
  {
    title: 'Progress check 2',
    date: '24 Jun 2023',
    status: 'Completed',
  },
  {
    title: 'Progress check 3',
    date: '24 Jun 2024',
    status: 'Pending',
  },
];
